import { Route } from '@angular/router';
import { CRM_ADVISORS_ROUTES } from './routing/advisors.routes';
import { CRM_CAMPAIGNS_ROUTES } from './routing/campaigns.routes';
import { CRM_DASHBOARD_ROUTES } from './routing/dashboard.routes';
import { CRM_INVENTORY_ROUTES } from './routing/inventory.routes';
import { CRM_LEADS_ROUTES } from './routing/leads.routes';
import { CRM_SALES_ROUTES } from './routing/sales.routes';
import { CRM_SUPPORT_ROUTES } from './routing/support.routes';

export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: 'dashboard', pathMatch: 'full', redirectTo: 'dashboard/leads/leads' },
  { path: 'leads', pathMatch: 'full', redirectTo: 'leads/tracking/tracking' },
  {
    path: 'campaigns',
    pathMatch: 'full',
    redirectTo: 'campaigns/campaigns/campaigns',
  },
  {
    path: 'advisors',
    pathMatch: 'full',
    redirectTo: 'advisors/advisors-managers/advisors-managers',
  },
  { path: 'sales', pathMatch: 'full', redirectTo: 'sales/clients/clients' },
  {
    path: 'support',
    pathMatch: 'full',
    redirectTo: 'support/service-requests/service-requests',
  },
  {
    path: 'inventory',
    pathMatch: 'full',
    redirectTo: 'inventory/projects/projects',
  },
  {
    // App Shell: única instancia del layout. Las páginas solo aportan contenido
    // y declaran su marco en `data.chrome`.
    path: '',
    loadComponent: () =>
      import('./shell/crm-shell.component').then((m) => m.CrmShellComponent),
    children: [
      ...CRM_DASHBOARD_ROUTES,
      ...CRM_LEADS_ROUTES,
      ...CRM_CAMPAIGNS_ROUTES,
      ...CRM_ADVISORS_ROUTES,
      ...CRM_SALES_ROUTES,
      ...CRM_SUPPORT_ROUTES,
      ...CRM_INVENTORY_ROUTES,
    ],
  },
];
